import React from "react";
import { Container } from "react-bootstrap";
import "../components/css/Testimonial.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";


import user3 from "../media/images/garary/testimanial4.png";
import user4 from "../media/images/garary/testimonial.png";
import user5 from "../media/images/garary/testimonial3.png";
import user2 from "../media/images/garary/testimal5.png";

const testimonials = [
  {
    text: "We hosted our wedding reception in the gardens, and it was simply magical...",
    name: "John & Esther L.",
    location: "Jinja",
    image: user3,
  },
  {
    text: "The pick-up from Entebbe Airport was smooth, the rooms were comfortable...",
    name: "Peter M.",
    location: "Nairobi",
    image: user2,
  },
  {
    text: "This resort is such a hidden gem on Mutungo Hill! The view is breathtaking...",
    name: "Grace N.",
    location: "Kampala",
    image: user5,
  },
  {
    text: "Father's House gave our team the quiet environment we needed for prayer, rest, ....",
    name: "DAVID M.",
    location: "USA",
    image: user4,
  },
];

const Testimonial = () => {
  return (
    <section className="testimonial-section py-5">
      <Container>

        {/* HEADER */}
        <div className="text-center mb-5" data-aos="fade-down">
          <small className="subtitle">TESTIMONIALS</small>
          <h2 className="title1">GUEST FEEDBACK</h2>
        </div>

        <Swiper
  modules={[Autoplay, Pagination]}
  slidesPerView={3}
  spaceBetween={30}
  loop={true}

  speed={1200} // 🧠 smooth transition (not too fast)

  autoplay={{
    delay: 3500, // ⏳ gives breathing space
    disableOnInteraction: false,
  }}

  grabCursor={true}

  breakpoints={{
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
           }}

            pagination={{ clickable: true }}
   >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card" data-aos="fade-up" data-aos-delay={index * 200}>
                <p className="text1">{item.text}</p>

                <div className="user-info">
                  <img src={item.image} alt="" />
                  <div>
                    <h5>{item.name}</h5>
                    <span>{item.location}</span>
                  </div>
                </div>

                <div className="quote">❞</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </Container>
    </section>
  );
};

export default Testimonial;